import { Send } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import AutocompleteComponent from 'components/design-system/Autocomplete/Autocomplete';
import ButtonComponent from 'components/design-system/Button/Button';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import Text from 'components/design-system/Text/Text';
import { ObtieneGrupos, ObtieneUnGrupo } from 'hooks/useServices';
import { useEffect } from 'react';

export const SolicitudGrupalForm = ({
  isSubmitting,
  setFieldValue,
  values,
  handleChange
}) => {
  const { grupos, isLoadingGrupos } = ObtieneGrupos();
  const { grupo, isLoadingGrupo, handleGrupo } = ObtieneUnGrupo();

  useEffect(() => {
    if (!values.grupo) return;
    handleGrupo(values.grupo.codigoGrupo);
  }, [values.grupo]);

  useEffect(() => {
    if (grupo && grupo.empresas) {
      setFieldValue('listadoNegociosEnGrupo', grupo.empresas);
    }
  }, [grupo, setFieldValue]);

  return (
    <div className="grid grid-cols-12 gap-5">
      <div className="col-span-12 md:col-span-6 xl:col-span-4">
        <AutocompleteComponent
          accesor="nombreGrupo"
          name="grupo"
          clearOnEscape={true}
          openOnFocus={false}
          value={values.grupo}
          isLoading={isLoadingGrupos}
          options={grupos || []}
          disabled={isLoadingGrupos || isSubmitting}
          getOptionLabel={option => option.nombreGrupo || ''}
          noOptionsText={'Sin opciones'}
          onChange={(ev, selected, reason) => {
            let data = {
              target: {
                name: 'grupo',
                value: selected
              }
            };
            if (reason === 'clear') {
              data.target.value = null;
              setFieldValue('listadoNegociosEnGrupo', null);
            }
            handleChange(data);
          }}
        >
          <InputComponent
            className="h-9"
            fullWidth
            label={<LabelComponent>Grupo</LabelComponent>}
          />
        </AutocompleteComponent>
      </div>
      <div className="col-span-8"></div>

      {isLoadingGrupo ? (
        <div className="col-span-12">
          <Skeleton variant="rounded" className="h-60 w-full" />
        </div>
      ) : (
        <>
          {values.listadoNegociosEnGrupo && (
            <>
              <div className="col-span-12">
                <div className="bg-background-primary p-5 rounded overflow-hidden w-full overflow-y-scroll max-h-[360px] scrollbar-uv border">
                  <ul className="px-5">
                    {values.listadoNegociosEnGrupo.map(empresa => (
                      <li className="list-disc py-1">
                        <Text>{empresa.empresa.nombreEmpresa}</Text>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-span-12">
                <ButtonComponent
                  form="solicitud-grupal"
                  buttonType="submit"
                  className="h-auto"
                  disabled={isSubmitting}
                >
                  Enviar invitación <Send className="ml-4" />
                </ButtonComponent>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
